// Dev Endpoints
// export const API_URL = 'https://95gpuenep5.execute-api.us-east-1.amazonaws.com/dev';
// export const ASSET_URL = 'https://durqj0jjnqscu.cloudfront.net/';

// PRD Endpoints
export const API_URL = 'https://t22ug79rm8.execute-api.us-east-1.amazonaws.com/prd';
export const ASSET_URL = 'https://assets.chrncl.com/';


// ID's of categories
export const VIDEO_ID = '6068df28-d5a2-4b9c-a344-4259ccf6b2a0';
export const BRAND_BOOK_ID = 'f6b342af-ef2c-4eee-81b9-2a8941694816';
export const FONT_ID = '7b405480-c445-4868-8ee7-fa4c8eddef1b';
export const PRODUCT_SHOTS_ID = '097e44bf-6463-4da0-a789-57325e8fbb29';
